// src/context/BranchContext.js
import { createContext, useContext, useState, useEffect } from 'react';

const BranchContext = createContext();
export const useBranch = () => useContext(BranchContext);

// Danh sách các branch cần redirect (trừ Hà Nội ra)
export const BRANCH_WEBSITES = {
    // hanoi: KHÔNG có trong danh sách này → sẽ không redirect
    HA_MI: 'https://hami-freiberg.de/',
    // thêm bao nhiêu cũng được, chỉ cần không có "hanoi"
};
export  const generateViewId = () => {
    return Math.floor(1000000000 + Math.random() * 9000000000).toString();
};
export const STORAGE_KEY = 'current_viewid';
export const BranchProvider = ({ children }) => {
    const [branch, setBranch] = useState(null); // luôn null khi mới vào

    useEffect(() => {

           if (branch && BRANCH_WEBSITES[branch]) {
                const targetUrl = BRANCH_WEBSITES[branch];
                let newViewId = generateViewId();
                if (window.location.origin !== new URL(targetUrl).origin) {
                    window.location.replace(`${targetUrl}?viewid=${newViewId}`);
                }
            }
    }, [branch]);
    return (
        <BranchContext.Provider value={{ branch, setBranch }}>
            {children}
        </BranchContext.Provider>
    );
};